var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5615",
    "data-name": "Grupo 5615",
    transform: "translate(6328 -2224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-lab",
    "data-name": "Icon metro-lab",
    d: "M19.122,14.5,13.806,6.263V2.928h.538a.521.521,0,0,0,.538-.5.521.521,0,0,0-.538-.5H8.966a.521.521,0,0,0-.538.5.521.521,0,0,0,.538.5H9.5V6.263L4.188,14.5c-1.218,1.886-.278,3.43,2.089,3.43H17.033c2.366,0,3.306-1.544,2.089-3.43ZM7.1,11.928l3.478-5.39V2.928h2.151v3.61l3.478,5.39Z",
    transform: "translate(-6329.655 2224.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3027",
    "data-name": "Ret\\xE2ngulo 3027",
    width: 20,
    height: 20,
    transform: "translate(-6328 2224)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLab);
export default __webpack_public_path__ + "static/media/icon_lab.26003a4b9107f296c651323e833e3ae3.svg";
export { ForwardRef as ReactComponent };